import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import { Boton } from './Boton';

/**
 * Frontera de error.
 *
 * Va DENTRO del shell y no envolviéndolo: si una pantalla se cae, el menú tiene
 * que seguir en pie para poder salir de ella. Con una `key` por ruta, cambiar de
 * pantalla ya reinicia el estado de error — así que navegar arregla.
 */
type Props = { children: ReactNode };
type Estado = { error: Error | null };

export class LimiteDeError extends Component<Props, Estado> {
  override state: Estado = { error: null };

  static getDerivedStateFromError(error: Error): Estado {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    // No se manda a ningún servicio externo: un error de render puede llevar
    // datos de la pantalla, y acá eso puede ser la respuesta de alguien.
    console.error('Pantalla caída:', error, info.componentStack);
  }

  override render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="mx-auto max-w-lg py-16 text-center">
        <h1 className="text-xl font-bold text-marino-800">Esta pantalla se cayó</h1>
        <p className="mt-2 text-sm leading-relaxed text-marino-500">
          El resto de la aplicación sigue funcionando. Puedes ir a otra sección desde el menú,
          o intentar de nuevo.
        </p>
        <Boton onClick={() => this.setState({ error: null })} className="mt-6">
          Intentar de nuevo
        </Boton>
      </div>
    );
  }
}
